module.exports = __webpack_public_path__ + "img/contribution.59cd3745.jpg";